export const calculateGreenFee = (UserList, hole, SelectedDate, Holiday, greenFeeMasterList, setGreenFeeList, setRateDetails) => {
    if (UserList.length === 0) return UserList;
    const day = moment(SelectedDate, 'YYYY-MM-DD').day();
    const isWeekend = (day === 6 || day === 0 || (Holiday !== null && Holiday !== undefined)) ? "Y" : "N";
    let subCatList = [];
    let totalGreenFee = 0;
    let cartCount = 0; 
    let caddyCount = 0;
    let memberShareCount = 0;
    let totalCartFee = 0;
    let totalCaddyFee = 0;
    let totalAmount = 0;
    let discountAmount = 0;
    let discount = 0;
    let tax = 0;
    let finalAmount = 0;
    let newGreenFeeList = [];
    const SelectedMoment = moment(SelectedDate, 'YYYY-MM-DD');
    
    let effectiveHole = isWeekend == "Y" ? 18 : hole;
    
    // Get specific fee structures
    const membersGuestFee = greenFeeMasterList.find(i => 
        i.SubCategoryID == 5 && 
        i.Hole == effectiveHole && 
        i.IsWeekend == isWeekend
    );
    
    const walkinGuestFee = greenFeeMasterList.find(i => 
        i.SubCategoryID == 3 && 
        i.Hole == effectiveHole && 
        i.IsWeekend == isWeekend
    );
    
    let updatedUserList = UserList.map(user => {
        const subscriptionExpired = user.SubscriptionExpiresOn
            ? moment(user.SubscriptionExpiresOn).isBefore(SelectedMoment)
            : true;

        const membershipExpired = user.MembershipExpiresOn
            ? moment(user.MembershipExpiresOn).isBefore(SelectedMoment)
            : true;

        const weekendRestriction =
            user.SubCategoryID === 7 && isWeekend === "Y";

        const isGuest =
            user.SubCategoryID === 3 || user.SubCategoryID === 5;

        const isValidMember =
            !subscriptionExpired &&
            !membershipExpired &&
            !weekendRestriction &&
            !isGuest
                ? "Y"
                : "N";

        return {
            ...user,
            IsValidMember: isValidMember,
            IsMembershipExpired: membershipExpired,
            IsSubscriptionExpired: subscriptionExpired
        };
    });

      // CART SHARING LOGIC
    if (updatedUserList.length == 1) {
        // Single player gets both cart and caddy
        updatedUserList[0].IsCartRequired = "Y";
        updatedUserList[0].IsCaddyRequired = "Y";
        updatedUserList[0].IsChecked = true;
        updatedUserList[0].IsDisabled = true;
    } else if (updatedUserList.length < 4) {
        // Logic for 2-3 players
        let memberCount = 0;
        let residentialMemberCount = 0;
        let guestCount = 0;
        let uncheckCount = 0;
        let residentUncheckCount = 0;
        let uncheckIndex = 5;
        let residentUncheckIndex = 5;
        
        // Count different user types
        updatedUserList.forEach((e) => {
            if (e.IsValidMember == "N") {
                e.IsCartRequired = "Y";
                e.IsCaddyRequired = "Y";
                e.IsChecked = true;
                e.IsDisabled = true;
            }
            if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y") {
                memberCount++;
            }
            
            if (e.SubCategoryID == 2 && e.IsValidMember == "Y") {
                residentialMemberCount++;
            }
            
            if (e.IsValidMember == "N") {
                guestCount++;
            }
        });
        
        // Helper function to update uncheck counts
        const updateUncheck = () => {
            uncheckCount = 0;
            residentUncheckCount = 0;
            uncheckIndex = 5;
            residentUncheckIndex = 5;
            
            updatedUserList.forEach((element, index) => {
                // Only consider unchecking for valid members, not guests
                if (element.IsCartRequired == "N") {
                    uncheckCount++;
                    uncheckIndex = index;
                
                    if (element.SubCategoryID == 2) {
                        residentUncheckCount++;
                        residentUncheckIndex = index;
                    }
                }
            });
        };
        
        // Process each user
        updatedUserList.forEach((e, i) => {
            // Skip cart sharing logic for guests - they must have cart and caddy
            // if (e.IsValidMember == "N") {
            //     return;
            // }
            
            updateUncheck();
            
            if ((memberCount == residentialMemberCount) && (memberCount == guestCount)) {
                if (e.SubCategoryID == 2) {
                    e.IsCartRequired = "Y";
                    e.IsCaddyRequired = "Y";
                    e.IsChecked = true;
                    e.IsDisabled = true;
                    updateUncheck();
                } else if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y" && !e.IsCartUpdated) {
                    e.IsCartRequired = "N";
                    e.IsCaddyRequired = "N";
                    e.IsChecked = false;
                    e.IsDisabled = false;
                    updateUncheck();
                }
            } else if ((memberCount == residentialMemberCount || guestCount == residentialMemberCount) && residentialMemberCount > 0) {
                if (e.SubCategoryID == 1 || e.SubCategoryID == 7) {
                    e.IsCartRequired = "Y";
                    e.IsCaddyRequired = "Y";
                    e.IsChecked = true;
                    e.IsDisabled = true;
                    updateUncheck();
                } else if (e.SubCategoryID == 2 && e.IsValidMember == "Y" && !e.IsCartUpdated) {
                    e.IsCartRequired = "N";
                    e.IsCaddyRequired = "N";
                    e.IsChecked = false;
                    e.IsDisabled = false;
                    updateUncheck();
                }
            } else if (memberCount == guestCount && memberCount > 0) {
                if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y" && !e.IsCartUpdated) {
                    e.IsCartRequired = "N";
                e.IsCaddyRequired = "N";
                e.IsChecked = false;
                e.IsDisabled = false;
                    updateUncheck();
                }
            } else if (residentialMemberCount == 2 && memberCount > 0) {
                if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) || (e.SubCategoryID == 2 && residentUncheckCount > 0 && i !== residentUncheckIndex)) {
                    e.IsCartRequired = "Y";
                e.IsCaddyRequired = "Y";
                e.IsChecked = true;
                e.IsDisabled = true;
                    updateUncheck();
                } else if (e.SubCategoryID == 2 && e.IsValidMember == "Y" && e.IsCartRequired == "Y" && uncheckCount == 0) {
                    if (!e.IsCartUpdated) {
                        e.IsCartRequired = "N";
                    e.IsCaddyRequired = "N";
                    e.IsChecked = false;
                    updateUncheck();
                }
                e.IsDisabled = false;
                }
            } else if (memberCount == 2 && residentialMemberCount > 0) {
                if (e.SubCategoryID == 2 || ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && uncheckCount > 0 && i !== uncheckIndex && updatedUserList[uncheckIndex].SubCategoryID !== 2)) {
                    e.IsCartRequired = "Y";
                e.IsCaddyRequired = "Y";
                e.IsChecked = true;
                e.IsDisabled = true;
                    updateUncheck();
                } else if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y" && e.IsCartRequired == "Y" && uncheckCount == 0) {
                    if (!e.IsCartUpdated) {
                        e.IsCartRequired = "N";
                    e.IsCaddyRequired = "N";
                    e.IsChecked = false;
                    updateUncheck();
                    }
                    e.IsDisabled = false;
                }
            } else if (memberCount > 1 && uncheckCount == 0) {
            if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y") {
                e.IsDisabled = false;
            }
            } else if (residentialMemberCount > 1 && uncheckCount == 0) {
            if (e.SubCategoryID == 2 && e.IsValidMember == "Y")
                e.IsDisabled = false;
            } else if (i !== uncheckIndex && uncheckCount > 0) {
                e.IsCartRequired = "Y";
                e.IsCaddyRequired = "Y";
                e.IsChecked = true;
                e.IsDisabled = true;
                updateUncheck();
            }
        });
        
        // Check for member sharing
        updatedUserList.forEach((e) => {
        
            if (residentialMemberCount > 0 && memberCount > 0 && guestCount == 0 && uncheckCount == 1 &&  e.SubCategoryID == 2 && e.IsValidMember == "Y" && e.IsCartRequired == "N") {
                memberShareCount = 1;
            }
        });
    } else {
        // Logic for 4+ players
        let uncheckCount = 0;
        let residentUncheckCount = 0;
        let residentUncheckIndex1 = 5;
        let residentUncheckIndex2 = 5;
        let uncheckIndex1 = 5;
        let uncheckIndex2 = 5;
        let memberCount = 0;
        let residentialMemberCount = 0;
        let guestCount = 0;
        let isMemberShared = false;
        let isResidentialShared = false;
        
        // Count different user types
        updatedUserList.forEach((e) => { 
            if (e.IsValidMember == "N") {
                e.IsCartRequired = "Y";
                e.IsCaddyRequired = "Y"; 
                e.IsChecked = true;
                e.IsDisabled = true;
            }           
            if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y") {
                memberCount++;
            }
            
            if (e.SubCategoryID == 2 && e.IsValidMember == "Y") {
                residentialMemberCount++;
            }
            
            if (e.IsValidMember == "N") {
                guestCount++;
            }
        });
        
        // Helper function to update uncheck counts
        const updateUncheck = () => {
            uncheckCount = 0;
            residentUncheckCount = 0;
            uncheckIndex1 = 5;
            uncheckIndex2 = 5;
            
            updatedUserList.forEach((element, index) => {
                // Only consider valid members for unchecking, not guests
                if (element.IsCartRequired == "N" ) {
                    uncheckCount++;
                
                    if (uncheckCount == 1) {
                        uncheckIndex1 = index;
                    }
                
                    if (uncheckCount > 1) {
                        uncheckIndex2 = index;
                    }
                
                    if (element.SubCategoryID == 2) {
                        residentUncheckCount++;
                    
                        if (residentUncheckCount == 1) {
                            residentUncheckIndex1 = index;
                        }
                    
                        if (residentUncheckCount > 1) {
                            residentUncheckIndex2 = index;
                        }
                    }
                }
            });
        };
        
        // Process each user for 4+ players
        updatedUserList.forEach((e, i) => {
            // Skip cart sharing logic for guests - they must have cart and caddy
            // if (e.IsValidMember == "N") {
            //     return;
            // }
            
            updateUncheck();
            
            if (guestCount > 1) {
                if (e.IsValidMember == "Y" && !e.IsCartUpdated) {
                    e.IsCartRequired = "N";
                    e.IsCaddyRequired = "N";
                    e.IsChecked = false;
                    e.IsDisabled = false;
                    updateUncheck();
                }
            } else if (residentialMemberCount == memberCount && residentialMemberCount == 2) {
                if ((e.SubCategoryID == 1 || e.SubCategoryID == 7)) {
                    e.IsCartRequired = "Y";
                    e.IsCaddyRequired = "Y";
                    e.IsChecked = true;
                    e.IsDisabled = true;
                    updateUncheck();
                } else if (e.SubCategoryID == 2 && e.IsValidMember == "Y" && !e.IsCartUpdated) {
                    e.IsCartRequired = "N";
                    e.IsCaddyRequired = "N";
                    e.IsChecked = false;
                    e.IsDisabled = false;
                    updateUncheck();
                }
                
                if (e.SubCategoryID == 2 && e.IsValidMember == "Y" && e.IsCartRequired == "N") {
                    memberShareCount++;
                }
            } else if (guestCount == memberCount && memberCount > 0) {
                if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y" && !e.IsCartUpdated) {
                    e.IsCartRequired = "N";
                    e.IsCaddyRequired = "N";
                    e.IsChecked = false;
                    e.IsDisabled = false;
                    updateUncheck();
                } else if (e.SubCategoryID == 2 && e.IsValidMember == "Y" && !e.IsCartUpdated) {
                    if (isResidentialShared) {
                        e.IsCartRequired = "Y";
                        e.IsCaddyRequired = "Y";
                        e.IsChecked = true;
                        e.IsDisabled = true;
                    } else {
                        e.IsCartRequired = "N";
                        e.IsCaddyRequired = "N";
                        isResidentialShared = true;
                        e.IsChecked = false;
                        e.IsDisabled = false;
                    }
                    updateUncheck();
                }else if (uncheckCount < 2 && (e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y") {
                e.IsDisabled = false;
                }
            } else if (memberCount == 2 || (memberCount == 3 && residentialMemberCount == 1)) {
                if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && 
                    ((updatedUserList[uncheckIndex1] && 
                    (updatedUserList[uncheckIndex1].SubCategoryID == 1 || updatedUserList[uncheckIndex1].SubCategoryID == 7) && 
                    updatedUserList[uncheckIndex1].IsCartRequired == "N" && i !== uncheckIndex1) ||
                    (updatedUserList[uncheckIndex2] && 
                    (updatedUserList[uncheckIndex2].SubCategoryID == 1 || updatedUserList[uncheckIndex2].SubCategoryID == 7) && 
                    updatedUserList[uncheckIndex2].IsCartRequired == "N" && i !== uncheckIndex2))) {
                
                    e.IsCartRequired = "Y";
                    e.IsCaddyRequired = "Y";
                    e.IsChecked = true;
                    e.IsDisabled = true;
                    updateUncheck();
                
                } else if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y" && !isMemberShared && !e.IsCartUpdated) {
                    e.IsCartRequired = "N";
                    e.IsCaddyRequired = "N";
                    e.IsChecked = false;
                    e.IsDisabled = false;
                    updateUncheck();
                    isMemberShared = true;
                } else if (e.SubCategoryID == 2 && e.IsValidMember == "Y") {
                    e.IsDisabled = false;
                }
                
                if (e.SubCategoryID == 2 && e.IsValidMember == "Y" && e.IsCartRequired == "N") {
                    memberShareCount++;
                }
            } else if (memberCount > 2 && uncheckCount < 2) {
            if ((e.SubCategoryID == 1 || e.SubCategoryID == 7) && e.IsValidMember == "Y")
                e.IsDisabled = false;

            } else if (residentialMemberCount > 2) {
                if (e.SubCategoryID == 2 && e.IsValidMember == "Y") {
                    if (residentUncheckCount < 2) {
                    if (e.IsCartUpdated) {
                e.IsDisabled = false;
                    } else {
                        e.IsCartRequired = "N";
                        e.IsCaddyRequired = "N";
                        e.IsChecked = false;
                        e.IsDisabled = false;
                        updateUncheck();
                    }
                    } else if (i !== residentUncheckIndex1 && i !== residentUncheckIndex2 && residentUncheckCount > 1) {
                        e.IsCartRequired = "Y";
                        e.IsCaddyRequired = "Y";
                        e.IsChecked = true;
                        e.IsDisabled = true;
                        updateUncheck();
                    }
                }
                else if (e.SubCategoryID == 1 || e.SubCategoryID == 7) {
                    e.IsCartRequired = "Y";
                    e.IsCaddyRequired = "Y";
                    e.IsChecked = true;
                    e.IsDisabled = true;
                    memberShareCount++;
                    updateUncheck();
                }
            } else if (i !== uncheckIndex1 && i !== uncheckIndex2 && uncheckCount > 1) {
                e.IsCartRequired = "Y";
                e.IsCaddyRequired = "Y";
                e.IsChecked = true;
                e.IsDisabled = true;
                updateUncheck();
            }
        });
        
        // Check for member sharing in 4+ players
        updatedUserList.forEach((e) => {
            if (residentialMemberCount > 0 && memberCount > 0 && guestCount > 0 && uncheckCount == 1 && 
                e.SubCategoryID == 2 && e.IsValidMember == "Y" && e.IsCartRequired == "N") {
                memberShareCount = 1;
            }
        });
    }
    
    updatedUserList = updatedUserList.map((user) => {
        let GreenFeeAmount;
        let CartFeeAmount;
        let CaddyFeeAmount;

        const greenFee = greenFeeMasterList.find((gf) =>
            (gf?.SubCategoryID === user.SubCategoryID ||
            (gf?.SubCategoryID === 1 && user.SubCategoryID === 7)) &&
            gf?.Hole === effectiveHole &&
            gf?.IsWeekend === isWeekend
        );

        if (user?.SubCategoryID === 1 || user?.SubCategoryID === 2 || user?.SubCategoryID === 7) {
            if (user?.IsValidMember === 'Y') {
                if (greenFee?.GreenFee > 0) {
                    GreenFeeAmount = greenFee?.GreenFee;
                }
                if (user?.IsCartRequired === "Y" && user?.IsCaddyRequired === "Y") {
                    CartFeeAmount = greenFee?.Cart;
                    CaddyFeeAmount = greenFee?.Caddy;
                } else if (user?.IsCartRequired === "Y") {
                    CartFeeAmount = greenFee?.Cart;
                } else if (user?.IsCaddyRequired === "Y") {
                    CaddyFeeAmount = greenFee?.Caddy;
                }
            } else {
                if (membersGuestFee?.GreenFee > 0) {
                    GreenFeeAmount = membersGuestFee?.GreenFee;
                }
                if (user?.IsCartRequired === "Y" && user?.IsCaddyRequired === "Y") {
                    CartFeeAmount = membersGuestFee?.Cart;
                    CaddyFeeAmount = membersGuestFee?.Caddy;
                } else if (user?.IsCartRequired === "Y") {
                    CartFeeAmount = membersGuestFee?.Cart;
                } else if (user?.IsCaddyRequired === "Y") {
                    CaddyFeeAmount = membersGuestFee?.Caddy;
                }
            }
        } else {
            if (greenFee?.GreenFee > 0) {
                if (user?.SubCategoryID == 5 && !!user?.couponCode) {
                    GreenFeeAmount = 0;
                } else {
                    GreenFeeAmount = greenFee?.GreenFee;
                }
            }
            if (user?.IsCartRequired === "Y" && user?.IsCaddyRequired === "Y") {
                CartFeeAmount = greenFee?.Cart;
                CaddyFeeAmount = greenFee?.Caddy;
            } else if (user?.IsCartRequired === "Y") {
                CartFeeAmount = greenFee?.Cart;
            } else if (user?.IsCaddyRequired === "Y") {
                CaddyFeeAmount = greenFee?.Caddy;
            }
        }

        return {
            ...user,
            greenFee: GreenFeeAmount,
            cartFee: CartFeeAmount,
            caddyFee: CaddyFeeAmount,
        };
    });

    updatedUserList.forEach((e) => {
        subCatList.push({
            userID: e.UserID,
            subID: e.SubCategoryID,
            IsValidMember: e.IsValidMember == "Y",
            IsCartRequired: e.IsCartRequired == "Y",
            IsCaddyRequired: e.IsCaddyRequired == "Y",
            couponCode: e.couponCode
        });
    });

    greenFeeMasterList.forEach((e) => {
        if (e.IsWeekend == isWeekend && e.Hole == effectiveHole) {
            subCatList.forEach((element) => {
                if (element.subID == e.SubCategoryID || (element.subID == 7 && e.SubCategoryID == 1)) {

                    if (element.subID == 1 || element.subID == 2 || element.subID == 7) {
                        if (element.IsValidMember) {
                            newGreenFeeList.push({ subCat: element, greenFee: e });
                        } else {
                            if (subCatList[0].IsValidMember)
                                newGreenFeeList.push({ subCat: element, greenFee: membersGuestFee });
                            else
                                newGreenFeeList.push({ subCat: element, greenFee: walkinGuestFee });
                        }
                    } 
                    else if (element.subID == 5) {
                        if (subCatList[0].IsValidMember)
                            newGreenFeeList.push({ subCat: element, greenFee: e });
                        else
                            newGreenFeeList.push({ subCat: element, greenFee: walkinGuestFee });
                    } else {
                        newGreenFeeList.push({ subCat: element, greenFee: e });
                    }
                }
            });
        }
    }); 


    newGreenFeeList.forEach((e) => {
      if (e.subCat.subID != 5 || !Boolean(e.subCat.couponCode)) {
            totalGreenFee += e.greenFee.GreenFee;
        }
        
        if (e.subCat.IsCartRequired) {
            totalCartFee += e.greenFee.Cart;
            cartCount++;
        }
        
        if (e.subCat.IsCaddyRequired) {
            totalCaddyFee += e.greenFee.Caddy;
            caddyCount++;
        }
    });

    totalGreenFee = parseFloat(totalGreenFee).toFixed(2);
    totalCartFee = parseFloat(totalCartFee).toFixed(2);
    totalCaddyFee = parseFloat(totalCaddyFee).toFixed(2);
    totalAmount = parseFloat(totalGreenFee) + parseFloat(totalCartFee) + parseFloat(totalCaddyFee);
    totalAmount = totalAmount.toFixed(2);

    // Calculate member share discount
    // if (memberShareCount > 0) {
    //   const memberGreenFee = newGreenFeeList.filter(i =>
    //     i.greenFee.SubCategoryID === 1 && i.greenFee.Hole === effectiveHole && i.greenFee.IsWeekend === isWeekend
    //   )[0];

    //   console.log("memberGreenFee",newGreenFeeList,newGreenFeeList[0].greenFee.SubCategoryID)
    
    
    //   if (memberGreenFee) {
    //     const shareDiscount = (memberGreenFee?.Cart + memberGreenFee?.Caddy) / 2;
    //     discountAmount = discountAmount + (shareDiscount * memberShareCount);
    //     discount = Math.round((discountAmount / parseFloat(totalAmount)) * 100);
    //   }
    // }

    if (memberShareCount > 0) {
        const memberGreenFee = newGreenFeeList.find(
            (i) =>
            i.greenFee?.SubCategoryID === 1 &&
            i.greenFee?.Hole === effectiveHole &&
            i.greenFee?.IsWeekend === isWeekend
        );
        
        if (memberGreenFee?.greenFee?.Cart != null && memberGreenFee?.greenFee?.Caddy != null) {
            const shareDiscount = (memberGreenFee?.greenFee?.Cart + memberGreenFee?.greenFee?.Caddy) / 2;
            discountAmount += shareDiscount * memberShareCount;
        
            discount = Math.round((discountAmount / parseFloat(totalAmount)) * 100);
        }
    }
    
    totalAmount = parseFloat(totalAmount) - discountAmount;
    // Calculate tax and final amount
    tax = (parseFloat(totalAmount) * 18) / 100;
    tax = tax.toFixed(2);

    finalAmount = parseFloat(totalAmount) + parseFloat(tax);
    finalAmount = Math.round(finalAmount);
    finalAmount = finalAmount.toFixed(2);

    setGreenFeeList(newGreenFeeList);
    setRateDetails({
        totalGreenFee,
        cartCount,
        caddyCount,
        totalCartFee,
        totalCaddyFee,
        totalAmount: parseFloat(totalAmount).toFixed(2),
        discountAmount,
        tax,
        finalAmount,
        discount
    })
    return updatedUserList;
}
